import { useEffect, useMemo, useState } from "react"
import MultiEditDialog from "~/components/planning/MultiEditDialog/MultiEditDialog"
import Commandbar from "~/components/planning/Commandbar"
import { useSelectedVariantHandlers } from "~/context/SelectedVariantsProvider"

interface HasSkuIds {
  variantId: string
  skuIds: string[]
}

type MultiEditInactiveSkuSettingsPanelProps = {
  selectedVariantCount: number
  clearSelectedSkuIds: () => void
}

export function MultiEditInactiveSkuSettingsPanel({
  selectedVariantCount,
  clearSelectedSkuIds,
}: MultiEditInactiveSkuSettingsPanelProps) {
  const { getSelectedVariants } = useSelectedVariantHandlers<HasSkuIds>()

  const [selectedVariants, setSelectedVariants] = useState<HasSkuIds[]>(() => getSelectedVariants())

  useEffect(() => {
    setSelectedVariants(getSelectedVariants())
  }, [getSelectedVariants, selectedVariantCount])

  const skuIds = useMemo(() => selectedVariants.flatMap((v) => v.skuIds), [selectedVariants])

  return (
    <>
      {selectedVariantCount > 0 && (
        <Commandbar count={selectedVariantCount} onClear={clearSelectedSkuIds}>
          <MultiEditDialog
            selectedSkuIds={skuIds}
            selectedVariantCount={selectedVariantCount}
            resetSelectedProductIds={clearSelectedSkuIds}
            commonVendors={[]}
          />
        </Commandbar>
      )}
    </>
  )
}
